<script setup lang="ts">
defineOptions({ name: 'LabeledSwitch' })

const model = defineModel<boolean>({ default: false })

defineProps<{
  label: string
}>()
</script>

<template>
  <label class="flex items-center gap-2 text-sm cursor-pointer">
    <span class="text-muted">{{ label }}</span>
    <USwitch v-model="model" size="xs" />
  </label>
</template>
